// eslint-disable-next-line import/prefer-default-export
export const removeDeviceTokenSerializer = (data = {}) => {
  const newData = {
    message: null
  }

  const { data: innerData = {} } = data

  newData.message = innerData.message

  return newData
}
